import { useEffect, useState } from 'react';
import { laboratoryClient } from './laboratoryClient';
import { VALUE_PROP_MODAL_CONFIGS } from '../ums/ValuePropModal/constants';
export const UPG_6101_TREATMENT_KEY = 'upg-6101';
export const useUPG6101Experiment = upgradeKey => {
  const isExperimentKey = (upgradeKey in VALUE_PROP_MODAL_CONFIGS);
  const [isUPG6101Variation, setIsUPG6101Variation] = useState(false);
  const [isUPG6101Fetched, setIsUPG6101Fetched] = useState(!isExperimentKey);
  useEffect(() => {
    if (!isUPG6101Fetched) {
      laboratoryClient.resolve(treatments => {
        var _Object$keys;
        if ((_Object$keys = Object.keys(treatments)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
          var _treatment$parameters;
          const treatment = treatments[UPG_6101_TREATMENT_KEY];
          if (treatment !== null && treatment !== void 0 && (_treatment$parameters = treatment.parameters) !== null && _treatment$parameters !== void 0 && _treatment$parameters.group) {
            setIsUPG6101Variation(treatment.parameters.group === 'variation');
          }
        }
        setIsUPG6101Fetched(true);
      });
    }
  }, [isUPG6101Fetched]);
  return {
    isUPG6101Variation,
    isUPG6101Fetched
  };
};